<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div>
    <validation-observer ref="loginValidation">
      <b-form
        class="auth-login-form mt-2"
        @submit.prevent
        enctype="multipart/form-data"
      >
        <div class="row">
          <div class="col-md-6">
            <b-form-group label="Page Title" label-for="title">
              <validation-provider
                #default="{ errors }"
                name="title"
                rules="required"
              >
                <b-form-input
                  id="title"
                  v-model="form.title"
                  :state="errors.length > 0 ? false : null"
                  name="title"
                  placeholder="Enter Your Page Title"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group label="Page Description" label-for="description">
              <validation-provider
                #default="{ errors }"
                name="description"
                rules="required"
              >
                <b-form-textarea
                  id="description"
                  v-model="form.description"
                  :state="errors.length > 0 ? false : null"
                  name="description"
                  placeholder="Enter Your Page Description"
                  rows="4"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group
              label="Admission Section Title"
              label-for="admission_section_title"
            >
              <validation-provider
                #default="{ errors }"
                name="admission_section_title"
                rules="required"
              >
                <b-form-input
                  id="admission_section_title"
                  v-model="form.admission_section_title"
                  :state="errors.length > 0 ? false : null"
                  name="admission_section_title"
                  placeholder="Enter Your Admission Section Title"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="Admission Section Description"
              label-for="admission_section_description"
            >
              <validation-provider
                #default="{ errors }"
                name="admission_section_description"
              >
                <b-form-textarea
                  id="admission_section_description"
                  v-model="form.admission_section_description"
                  :state="errors.length > 0 ? false : null"
                  name="admission_section_description"
                  placeholder="Enter Your Admission Section Description"
                  rows="4"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group
              label="Comment Section Title"
              label-for="comment_section_title"
            >
              <validation-provider
                #default="{ errors }"
                name="comment_section_title"
                rules="required"
              >
                <b-form-input
                  id="comment_section_title"
                  v-model="form.comment_section_title"
                  :state="errors.length > 0 ? false : null"
                  name="comment_section_title"
                  placeholder="Enter Your Comment Section Title"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="Comment Section Description"
              label-for="comment_section_description"
            >
              <validation-provider
                #default="{ errors }"
                name="comment_section_description"
              >
                <b-form-textarea
                  id="comment_section_description"
                  v-model="form.comment_section_description"
                  :state="errors.length > 0 ? false : null"
                  name="comment_section_description"
                  placeholder="Enter Your Comment Section Description"
                  rows="4"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group label="Meta Title" label-for="meta_title">
              <validation-provider
                #default="{ errors }"
                name="meta_title"
                rules="required"
              >
                <b-form-input
                  id="meta_title"
                  v-model="form.meta_title"
                  :state="errors.length > 0 ? false : null"
                  name="meta_title"
                  placeholder="Enter Your Meta Title"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group label="Meta Description" label-for="meta_description">
              <validation-provider
                #default="{ errors }"
                name="meta_description"
                rules="required"
              >
                <b-form-textarea
                  id="meta_description"
                  v-model="form.meta_description"
                  :state="errors.length > 0 ? false : null"
                  name="meta_description"
                  placeholder="Enter Your Meta Description"
                  rows="4"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
        </div>

        <!-- submit buttons -->
        <b-button type="submit" variant="primary" @click="validationForm">
          Update
        </b-button>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BMediaBody,
  BMediaAside,
  BMedia,
  BFormFile,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BFormTextarea,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
export default {
  data() {
    return {
      form: {
        title: "",
        description: "",
        admission_section_title: "",
        admission_section_description: "",
        comment_section_title: "",
        comment_section_description: "",
        meta_title: "",
        meta_description: "",
      },
      required,
      email,
    };
  },
  mounted() {
    this.getCoursePage();
  },
  methods: {
    async getCoursePage() {
      const course_page = await this.callApi("get", "/app/course/page/show");
      if (course_page.status == 200) {
        this.form.title = course_page.data.course_page.title;
        this.form.description = course_page.data.course_page.description;

        this.form.admission_section_title =
          course_page.data.course_page.admission_section_title;
        this.form.admission_section_description =
          course_page.data.course_page.admission_section_description;

        this.form.comment_section_title =
          course_page.data.course_page.comment_section_title;
        this.form.comment_section_description =
          course_page.data.course_page.comment_section_description;

        this.form.meta_title = course_page.data.course_page.meta_title;
        this.form.meta_description =
          course_page.data.course_page.meta_description;
      }
    },
    Update() {
      axios
        .post("/app/course/page/update", this.form)
        .then((res) => {
          this.getCoursePage();
          this.s(res.data.message);
        })
        .catch((e) => {
          if (e.response.status === 422) {
            if (e.response.data.errors.title)
              this.e(e.response.data.errors.title[0]);
            if (e.response.data.errors.description)
              this.e(e.response.data.errors.description[0]);
            if (e.response.data.errors.admission_section_title)
              this.e(e.response.data.errors.admission_section_title[0]);
            if (e.response.data.errors.admission_section_description)
              this.e(e.response.data.errors.admission_section_description[0]);
            if (e.response.data.errors.meta_title)
              this.e(e.response.data.errors.meta_title[0]);
            if (e.response.data.errors.meta_description)
              this.e(e.response.data.errors.meta_description[0]);
          }
        });
    },
    validationForm() {
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          this.Update();
        }
      });
    },
  },
  computed: {},
  components: {
    vSelect,
    BMedia,
    BFormFile,
    BFormTextarea,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BMediaAside,
    BMediaBody,
  },
};
</script>

<style></style>
